import LeadeboardContext from 'contexts/leaderboard';
import Challenges from 'pages/Challenges';
import ChallengePage from 'pages/ChallengePage';
import { useEffect, useState } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import 'styles/base.css';
import HomePage from './pages/HomePage';
import { LeaderboardMeta } from 'types/leaderboard';
import LoginPage from 'pages/LoginPage';
import { UserProvider } from 'contexts/user';
import { Registration, User } from 'types/user';
import { SnackbarProvider } from 'notistack';
import ProfilePage from 'pages/ProfilePage';
import SubmissionPage from 'pages/SubmissionPage';
import {
  getSULabTokenString,
  login,
  logout,
} from 'actions/auth';
import RegistrationIntoChallengePage from 'pages/RegistrationIntoChallengePage';
import PastSubmissionsPage from 'pages/PastSubmissionsPage';
import { fetchChallenge } from 'actions/leaderboard';
import AdminPage from 'pages/AdminPage';
import LoginRoute from 'components/Routes/LoginRoute';
import AdminRoute from 'components/Routes/AdminRoute';
import ChallengeManagePage from 'pages/ChallengeManagePage';
import ChallengeAllSubmissionsPage from 'pages/ChallengeAllSubmissionsPage';
import NotFound from 'pages/NotFound';
import ManiSkill2021HomePage from 'pages/ManiSkill2021/home';
import ManiSkill2021ResultsPage from 'pages/ManiSkill2021/ResultsPage';
import ChallengeTeamPage from 'pages/ChallengeTeamPage';
import { fetchRegistration } from 'actions/challenge';
import ManiSkill2ChallengeResultsPage from 'pages/PastResults/ManiSkill2ChallengeResultsPage';

function App() {
  const [leaderboards, setLeaderboards] = useState<
    Record<string, LeaderboardMeta>
  >({});
  const getChallenge = async (challengeIds: string[]) => {
    let newleaderboards = {...leaderboards};
    let requests: Promise<void>[] = [];
    for (const challengeId of challengeIds) {
      requests.push(
        fetchChallenge(challengeId).then((data) => {
          newleaderboards[data.slug] = data;
        })
      );
    }
    await Promise.all(requests);
    setLeaderboards(newleaderboards);
    return newleaderboards;
  };
  const [user, setUser] = useState<User>();
  const [registrations, setRegistration] = useState<Record<string,Registration>>({});
  const getRegistration = async (challengeId: string) => {
    let newregistrations = registrations;
    const data = await fetchRegistration(challengeId);
    newregistrations[data.challengeId] = data;
    setRegistration(newregistrations);
    return data;
  }
  const [fetchingUser, setFetchingUser] = useState(true);
  useEffect(() => {
    let token = getSULabTokenString();
    if (token !== null) {
      login(token)
        .then(setUser)
        .then(() => {
          setFetchingUser(false);
        })
        .catch((err) => {
          setFetchingUser(false);
          logout();
        });
    } else {
      setFetchingUser(false);
    }
  }, []);
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <SnackbarProvider>
          <UserProvider
            value={{
              user,
              setUser,
              fetching: fetchingUser,
              registrations: registrations,
              getRegistration: getRegistration
            }}
          >
            <LeadeboardContext.Provider
              value={{
                leaderboards,
                setLeaderboards,
                getChallenge,
              }}
            >
              <Switch>
                
                <Route exact path="/2021" component={ManiSkill2021HomePage} />
                <Route exact path="/2021/result" component={ManiSkill2021ResultsPage} />
                <Route exact path="/" component={HomePage} />
                <Route exact path="/login" component={LoginPage} />
                <AdminRoute exact path="/admin" component={AdminPage} />
                <Route exact path="/past-results/maniskill2-challenge" component={ManiSkill2ChallengeResultsPage} />
                <Route exact path="/challenges" component={Challenges} />
                <Route exact path="/challenges/:id" component={ChallengePage} />
                <AdminRoute
                  exact
                  path="/challenges/:id/admin"
                  component={ChallengeManagePage}
                />
                <AdminRoute
                  exact
                  path="/challenges/:id/admin/submissions"
                  component={ChallengeAllSubmissionsPage}
                />

                <LoginRoute
                  exact
                  path="/challenges/:id/submit"
                  component={SubmissionPage}
                />
                <LoginRoute
                  exact
                  path="/challenges/:id/register"
                  component={RegistrationIntoChallengePage}
                />
                <LoginRoute
                  exact
                  path="/challenges/:id/team"
                  component={ChallengeTeamPage}
                />
                <LoginRoute exact path="/profile" component={ProfilePage} />
                <LoginRoute
                  exact
                  path="/profile/submissions/:challengeId"
                  component={PastSubmissionsPage}
                />
                <Redirect exact from="/2022" to="/" />
                <Route component={NotFound} />
              </Switch>
            </LeadeboardContext.Provider>
          </UserProvider>
        </SnackbarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
